export enum ActivationStatus {
  PendingReview = 'pending_review',
  Activated = 'activated',
  Completed = 'completed',
}

export interface StepStatus {
  completed: boolean;
  completedAt?: string;
  status?: string;
}

export interface ActivateCurrencyData {
  currency: string;
  status: ActivationStatus;
  steps: {
    tnc: StepStatus;
    edd?: StepStatus;
    poa: StepStatus;
  };
}

export interface ActivateCurrencyResponse {
  data: ActivateCurrencyData;
  message: string;
  code?: number;
}
